import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button, Press, haptic } from '@dorixona/ui'
import { Sheet } from '../../ui/Sheet'
import { Icon } from '../../ui/Icon'
import { useSession } from '../../app/session'
import { useDeleteAccount } from './api'
import { deleteFailureText } from './model'

export interface DeleteAccountSheetProps {
  opened: boolean
  onClose: () => void
}

/**
 * Подтверждение удаления аккаунта. Действие необратимое, поэтому шторка
 * говорит, что пропадёт, а кнопка называет действие словом. Удалили — сессия
 * закрывается, покупатель на главной гостем.
 */
export function DeleteAccountSheet({ opened, onClose }: DeleteAccountSheetProps) {
  const { t } = useTranslation(['account', 'common'])
  const navigate = useNavigate()
  const { signOut } = useSession()
  const remove = useDeleteAccount()

  const close = () => {
    remove.reset()
    onClose()
  }

  return (
    <Sheet opened={opened} label={t('account:delete.title')} onClose={close}>
      <div className="fsheet">
        <div className="fhead">
          <h2>{t('account:delete.title')}</h2>
          <Press
            squish="icon"
            className="fclose"
            aria-label={t('common:actions.close')}
            onPress={close}
          >
            <Icon name="i-x" size={18} />
          </Press>
        </div>
        <p className="cardform-lead">{t('account:delete.lead')}</p>
        {remove.isError ? (
          <p className="acc-note acc-note-err" role="alert">
            {deleteFailureText(remove.error, t)}
          </p>
        ) : null}
        <div className="ffoot">
          <Button variant="ghost" onPress={close}>
            {t('common:actions.cancel')}
          </Button>
          <Button
            className="btn-danger"
            disabled={remove.isPending}
            onPress={() => {
              remove.mutate(undefined, {
                onSuccess: () => {
                  signOut()
                  void navigate('/', { replace: true })
                },
                onError: () => {
                  haptic('error')
                },
              })
            }}
          >
            {remove.isPending ? t('account:delete.deleting') : t('account:delete.confirm')}
          </Button>
        </div>
      </div>
    </Sheet>
  )
}
